import React from "react";

const clientLogos = [
  "/img/client-logos/1.png",
  "/img/client-logos/2.png",
  "/img/client-logos/3.png",
  "/img/client-logos/4.png",
  "/img/client-logos/5.png",
  "/img/client-logos/6.png",
  "/img/client-logos/7.png",
  "/img/client-logos/8.png",
  "/img/client-logos/9.png",
  "/img/client-logos/10.png",
  "/img/client-logos/11.png",
  "/img/client-logos/12.png",
  "/img/client-logos/13.png",
  "/img/client-logos/14.png",
  "/img/client-logos/15.png",
  "/img/client-logos/16.png",
  "/img/client-logos/17.png",
  "/img/client-logos/18.png",
  "/img/client-logos/19.png",
  "/img/client-logos/20.png",
  "/img/client-logos/21.png",
  "/img/client-logos/22.png",
  "/img/client-logos/23.png",
  "/img/client-logos/24.png",
  "/img/client-logos/25.png",
  "/img/client-logos/26.png",
];

const row1 = clientLogos.slice(0, 9);
const row2 = clientLogos.slice(9, 18);
const row3 = clientLogos.slice(18, 26);

const LogoRow = ({ logos, reverse = false }) => (
  <div className={`logo-row ${reverse ? "reverse" : ""}`}>
    <div className="logo-track">
      {[...logos, ...logos].map((logo, index) => (
        <div className="logo-item" key={index}>
          <img src={logo} alt={`Client ${index + 1}`} />
        </div>
      ))}
    </div>
  </div>
);

const Clients = () => {
  return (
    <section className="clients-section">
      <div className="container">
        <div className="section-heading text-center mb-5">
          <span className="subtitle">TRUSTED BY BRANDS</span>
          <h2>Clients & Collaborations</h2>
        </div>

        <div className="logos-wrapper">
          <LogoRow logos={row1} />
          <LogoRow logos={row2} reverse />
          <LogoRow logos={row3} />
        </div>
      </div>

      <style>{`
        .clients-section {
          overflow: hidden;
          padding: 100px 0;
          position: relative;
        }

        .section-heading h2 {
          font-size: 3rem;
          margin-top: 10px;
        }

        .subtitle {
          font-size: 14px;
          letter-spacing: 2px;
          opacity: 0.6;
        }

        .logos-wrapper {
          display: flex;
          flex-direction: column;
          gap: 30px;
        }

        .logo-row {
          overflow: hidden;
          position: relative;
        }

        .logo-track {
          display: flex;
          width: max-content;
          animation: scroll 35s linear infinite;
        }

        .logo-row.reverse .logo-track {
          animation-direction: reverse;
        }

        .logo-row:hover .logo-track {
          animation-play-state: paused;
        }

        .logo-item {
          width: 220px;
          height: 120px;
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 25px;
          transition: 0.4s ease;
          backdrop-filter: blur(10px);
        }

        .logo-item:hover {
          transform: translateY(-8px) scale(1.03);
          border-color: rgba(255,255,255,0.2);
        }

        .logo-item img {
          width: 50%;
  height: 100%;
  object-fit: fill;
   opacity: .95;
  
  transition: .4s ease;
        }
          
 

.logo-item:hover img{
  opacity: 1;
  transform: scale(1);
}

        .logo-item:hover img {
         
          opacity: 1;
        }

        @keyframes scroll {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }

        @media (max-width: 768px) {
          .logo-item {
            width: 160px;
            height: 90px;
          }

          .logo-item img {
            max-width: 90px;
          }

          .section-heading h2 {
            font-size: 2rem;
          }
        }
      `}</style>
    </section>
  );
};

export default Clients;